import * as React from "react";
const GameStateAdditionalData = props => {
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: `rj-ev-list__game-state__current-down`, "data-uat": `ev-list-game-state-current-down` },
            ", ",
            props.currentDown),
        React.createElement("span", { className: `rj-ev-list__game-state__down-separator`, "data-uat": `ev-list-game-state-down-separator` }, props.separator),
        React.createElement("span", { className: `rj-ev-list__game-state__yards-to-go`, "data-uat": `ev-list-game-state-yards-to-go` }, props.yardsToGo),
        React.createElement("span", { className: `rj-ev-list__game-state__side`, "data-uat": `ev-list-game-state-side` }, props.side),
        React.createElement("span", { className: `rj-ev-list__game-state__yard-line`, "data-uat": `ev-list-game-state-yard-line` }, props.yardLine)));
};
GameStateAdditionalData.displayName = "GameStateAdditionalData";
export default React.memo(GameStateAdditionalData);
//# sourceMappingURL=GameStateAdditionalData.js.map